import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useState } from "react";

const IngresoContraseña = ({ control, errors }) => {
  const [password1, setPassword1] = useState(""); // Estado para la primera contraseña
  const [password2, setPassword2] = useState(""); // Estado para la segunda contraseña
  const [showPassword, setShowPassword] = useState(false); // Estado para controlar la visibilidad de la contraseña

  // Función para alternar la visibilidad de la contraseña
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <Controller
        name="password"
        control={control}
        defaultValue=""
        rules={{
          required: "Ingrese su nueva contraseña",
          minLength: {
            value: 8,
            message: "La contraseña debe tener al menos 8 caracteres.",
          },
        }}
        render={({ field }) => (
          <Form.Group>
            <Form.Label>Ingresar nueva contraseña</Form.Label>
            <Form.Control
              type={showPassword ? "text" : "password"} // Mostrar como texto o contraseña
              {...field}
              value={password1}
              onChange={(e) => {
                setPassword1(e.target.value);
                field.onChange(e);
              }}
              isInvalid={!!errors.password}
            />
            {errors.password && (
              <Form.Control.Feedback type="invalid">
                {errors.password.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        )}
      />

      <Controller
        name="password_2"
        control={control}
        defaultValue=""
        rules={{
          required: "Confirme su contraseña",
          validate: (value) =>
            value === password1 || "Las contraseñas no coinciden",
        }}
        render={({ field }) => (
          <Form.Group>
            <Form.Label>Confirmar contraseña</Form.Label>
            <Form.Control
              type={showPassword ? "text" : "password"} // Mostrar como texto o contraseña
              {...field}
              value={password2}
              onChange={(e) => {
                setPassword2(e.target.value);
                field.onChange(e); // Necesario para actualizar el valor en react-hook-form
              }}
              isInvalid={!!errors.password_2}
            />
            {errors.password_2 && (
              <Form.Control.Feedback type="invalid">
                {errors.password_2.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        )}
      />

      {/* Botón para alternar visibilidad de la contraseña */}
      <Form.Group>
        <Form.Check
          type="checkbox"
          label="Mostrar contraseña"
          onChange={togglePasswordVisibility}
        />
      </Form.Group>
    </div>
  );
};

export default IngresoContraseña;
